module.exports = __webpack_public_path__ + "static/media/26_plantilla_navidad_combo_dua_cuadrada_cinta_1_motivo_1.f5e7042d.png";